import { render, staticRenderFns } from "./PikeCustomFields.vue?vue&type=template&id=56c387b7&scoped=true&"
import script from "./PikeCustomFields.vue?vue&type=script&lang=js&"
export * from "./PikeCustomFields.vue?vue&type=script&lang=js&"
import style0 from "./PikeCustomFields.vue?vue&type=style&index=0&id=56c387b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c387b7",
  null
  
)

export default component.exports